module.exports = __webpack_public_path__ + "static/hero-top-sp-3b57c2e9d2e0c759aa93d0a38ccedb7f.png";